
// Checl Window event Listener on Click Addtocart on Config product popup
window.addEventListener("message", manageEventListner, true);
var termConditionURL = "https://www.derek-rose.com/pages/terms-and-conditions";
function closePopup() {
  document.body.style.overflow = "unset";
  document.body.style.height = "unset";
  document.body.style.margin = "inherit";
  document.getElementById("popup-overlay").style.display = "none";
} 
$('#popup-overlay .popupOverlay-trigger').on("click", function(){
  closePopup();
});
$(document).on('keydown', function(event) {
   if (event.key == "Escape") {
       if(document.getElementById("popup-overlay").style.display == "block"){
         closePopup();
       }
   }
});

function addClass(data){
  $(".product__media-item").each(function(imageData){
    $(this).removeClass("is-selected");
  });
  var classaddData = $(data).parent().parent();
  $(classaddData).addClass("is-selected");
  //console.log("this", $(data).parent().parent().parent().addClass("is-selected"));
}
function closeZoomPopup(zoomPopup){
  // console.log("zoomPopup", zoomPopup);
  // var removeClass = $(zoomPopup).parent();
  // console.log("removeClass", removeClass);
  // $(removeClass).removeAttr('class');
  zoomPopup.delegate.off("pswpTap");
}
window.addEventListener("load", (event) => {
   if($(window).width() <= 800) {
     if($("#feefo-product-review-widgetId").length > 0){
       $("#feefo-product-review-widgetId").find(".mobile-comments-accordion").click();
     }
   }
});

function openPopup(action) {
  
  document.body.style.overflow = "unset";
  document.body.style.height = "unset";
  document.body.style.margin = "inherit";
  //console.log(window.Shopify.currency.active)
  let iframeUrl = '';
  if(action == "AddMonogram"){
    let myPriceString = monogramVariantPrices.join("_");
    // iframeUrl = derekRoseSSLPath + "/monogrambuilder?prdId=" + productId + "&price="+ monogramPrice + "&priceString="+ myPriceString + "&code="+ window.Shopify.currency.active +"&variantId =" + document.querySelector('.selected-prdt').value
    iframeUrl = derekRoseSSLPath + "/personalisebuilder?prdId=" + productId + "&price="+ monogramPrice + "&priceString="+ myPriceString + "&code="+ window.Shopify.currency.active +"&variantId =" + document.querySelector('.selected-prdt').value + "&addInitially=true";
  }
  else if(action == "EditMonogram"){
    iframeUrl = editUrl.href;
  }
  else if(action == "EditMotif"){
    iframeUrl = motifEditUrl.href;
  }
  else if(action == "EditSecretMsg"){
    iframeUrl = encodeURI(secretMsgEditUrl.href);
  }
  $('.maintext').html( '<iframe src="' + iframeUrl + '">' );
  document.getElementById("popup-overlay").style.display = "block";
} 

function deleteMonogram() {
  //Hiding the Add monogram Button 
  document.querySelector('.monogram-before').style.display = '';
  document.querySelector('.customiser-price-feld.old-added').style.display = '';
  document.querySelector('.monogram-after.new-added').style.display = 'none';
  document.querySelector('.monogram-after.new-added').innerHTML = '';
  document.querySelector('.monogramming-extra-price').style.display = `none`;
  document.getElementById("monogramming-details").value = '';
  document.querySelector('.sew-text.old-added').style.display = '';
  document.querySelector('.sew-text.new-added').style.display = 'none';
  document.querySelector('.sew-text.new-added').innerHTML = '';
  document.querySelector('.customiser-price-feld.new-added').style.display = 'none';
  document.querySelector('.customiser-price-feld.new-added').innerHTML = '';
  document.querySelector('.customiser-label-top').classList.remove('monogram-added');
  document.querySelector('.sew-icon').style.backgroundImage = "url(https://cdn.shopify.com/s/files/1/0644/9460/0412/files/CLIENT-_v3_Website_Project_-Monogramming-_05-08-2022-_-Figma.png?v=1663649874)";

}

function manageEventListner(event) {
	var data = event.data;
	if( typeof(data.eventTriggered) != "undefined" && data.eventTriggered == "productAddToCart" ){
		
        // Adding monogram details to dom
        let personaliseBtn = document.querySelector(".customiser-label-top");
        personaliseBtn.classList.add('monogram-added');

        let monogramRtnData = `Your Monogram Option: 
                                  <span>
                                    ${data.initials.toUpperCase()} / 
                                    ${data.font} / 
                                    ${data.color} / 
                                    ${data.size}
                                  </span>
                                  <span class="personalisation-details">_Monogram Reference:${data.initials.toUpperCase()} / ${data.font} / ${data.color} / ${data.size}</span>`;
      
        let monogramDetailsDom =  document.querySelector('.monogram-after.new-added');       
        let monogramDetails  = `<span class="monogram-details">
                                  <svg style="display:inline-block; vertical-align:middle" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 0C2.68548 0 0 2.70968 0 6C0 9.31452 2.68548 12 6 12C9.29032 12 12 9.31452 12 6C12 2.70968 9.29032 0 6 0ZM6 2.66129C6.55645 2.66129 7.01613 3.12097 7.01613 3.67742C7.01613 4.25806 6.55645 4.69355 6 4.69355C5.41935 4.69355 4.98387 4.25806 4.98387 3.67742C4.98387 3.12097 5.41935 2.66129 6 2.66129ZM7.35484 8.80645C7.35484 8.97581 7.20968 9.09677 7.06452 9.09677H4.93548C4.76613 9.09677 4.64516 8.97581 4.64516 8.80645V8.22581C4.64516 8.08064 4.76613 7.93548 4.93548 7.93548H5.22581V6.3871H4.93548C4.76613 6.3871 4.64516 6.26613 4.64516 6.09677V5.51613C4.64516 5.37097 4.76613 5.22581 4.93548 5.22581H6.48387C6.62903 5.22581 6.77419 5.37097 6.77419 5.51613V7.93548H7.06452C7.20968 7.93548 7.35484 8.08064 7.35484 8.22581V8.80645Z" fill="#000"></path>
                                  </svg><span style="display:inline-block; vertical-align:middle">&nbsp; <span style="border-bottom: 1px solid black;"> <a href="${termConditionURL}" target="_blank" >Terms &amp; Conditions</a></span> Accepted</span>
                                </span>`;
        monogramDetails += `<span class="monogram-update">
                        <a href="javascript:;" onclick="openPopup('EditMonogram')" class="monogram-edit">Edit</a> |
                        <a href="javascript:;" onclick="deleteMonogram()" class="monogram-delete">Remove</a>
                      </span>`;
      
        monogramDetailsDom.innerHTML = monogramDetails;
        monogramDetailsDom.style.display = "";
      
        document.querySelector('.customiser-price-feld.new-added').innerHTML = monogramRtnData;
        document.querySelector('.customiser-price-feld.new-added').style.display = "";
        personaliseBtn.style.display = "";
        
        //Updating the preview image of monogram (Not Required Now) 
        //document.querySelector('.sew-icon').style.backgroundImage = "url('" + data.imageDataURI + "')";
       
        //Hiding the Add monogram Button 
        document.querySelector('.monogram-before').style.display = 'none';
        document.querySelector('.customiser-price-feld.old-added').style.display = 'none';
        document.querySelector('.sew-text.old-added').style.display = 'none';
      
        //Remove Popup
		document.body.style.overflow = "unset";
        document.body.style.height = "unset";
        document.body.style.margin = "inherit";
        document.getElementById("popup-overlay").style.display = "none";
      
  		var cardType = "SC"; // Not used now - remove if not used
		var cartProperties = {};

        cartProperties['_is_monogrammed'] = 'Yes';
        cartProperties['Initials'] = data.initials;
        cartProperties['Font'] = data.font;
        cartProperties['Colour'] = data.color;
        cartProperties['Size'] = data.size;
        cartProperties['_Related Product Id'] = data.parentProductId;
        cartProperties['_Related Product Name'] = "";
        cartProperties['_Reference Image'] = data.imageDataURI;
      
        let imageUrl = new URL(data.imageDataURI);
      
        if(editUrl.searchParams.has('fontSize')){
           editUrl.searchParams.set('fontSize', imageUrl.searchParams.get("size"));
        }
        else{
           editUrl.searchParams.append('fontSize', imageUrl.searchParams.get("size"));
        }
        
        if(editUrl.searchParams.has('fontColor')){
           editUrl.searchParams.set('fontColor', imageUrl.searchParams.get("color"));
        }
        else{
           editUrl.searchParams.append('fontColor', imageUrl.searchParams.get("color"));
        }
        
        if(editUrl.searchParams.has('fontId')){
           editUrl.searchParams.set('fontId', imageUrl.searchParams.get("font"));
        }
        else{
           editUrl.searchParams.append('fontId', imageUrl.searchParams.get("font"));
        }
  
        if(editUrl.searchParams.has('initials')){
           editUrl.searchParams.set('initials', imageUrl.searchParams.get("image"));
        }
        else{
           editUrl.searchParams.append('initials', imageUrl.searchParams.get("image"));
        }
        
        // monogramEditPrice = parseInt(data.initials.length) * parseInt(monogramPrice)
        // monogramEditPrice = (data.initials.length * monogramPrice).toFixed(2);
        monogramEditPrice = monogramVariantPrices[data.initials.length - 1];

        if(editUrl.searchParams.has('price')){
           editUrl.searchParams.set('price', monogramPrice);
        }
        else{
           editUrl.searchParams.append('price', monogramPrice);
        }

        if(editUrl.searchParams.has('editPrice')){
           editUrl.searchParams.set('editPrice', monogramEditPrice);
        }
        else{
           editUrl.searchParams.append('editPrice', monogramEditPrice);
        }
        
        let myPriceStringEdit = monogramVariantPrices.join("_");
        if(editUrl.searchParams.has('editPrice')){
           editUrl.searchParams.set('priceString', myPriceStringEdit);
        }
        else{
           editUrl.searchParams.append('priceString', myPriceStringEdit);
        }

        if(editUrl.searchParams.has('code')){
           editUrl.searchParams.set('code', window.Shopify.currency.active);
        }
        else{
           editUrl.searchParams.append('code', window.Shopify.currency.active);
        }

        if(editUrl.searchParams.has('editMonogram')){
           editUrl.searchParams.set('editMonogram', "true");
        }
        else{
           editUrl.searchParams.append('editMonogram', "true");
        }
   
		/* add product into the cart */
        let productId = data.initials.length - 1;
        var strToChange = {
          id : monogramArray[productId],
          properties: cartProperties,
          quantity: data.quantity
        }
       
        var Cartitems = {};
        Cartitems['items'] = [];
        Cartitems.items.push(strToChange); 
      
        document.getElementById("monogramming-details").value = JSON.stringify(strToChange);
         let monogramExtraPrice = monogramEditPrice * 1000;
         const options = { style: 'currency', currency: window.Shopify.currency.active };
         /*
         const numberFormat = new Intl.NumberFormat( "en-US" , options);
         const parts = numberFormat.formatToParts(monogramExtraPrice/1000); 

         var priceMonogram = `${parts[0].value}${parts[1].value}${parts[2].value}${parts[3].value}`;

         if(window.Shopify.currency.active  == 'EUR'){
           priceMonogram = priceMonogram.replace(".", ",");
         }
         */

         if(document.querySelector('.sew-text.new-added')){
           document.querySelector('.sew-text.new-added').innerHTML = `Personalisation: Monogram <span class="monogramming-extra-price"> ${monogramEditPrice}</span>`;
           document.querySelector('.sew-text.new-added').style.display = ``;
         }
        
         // if(document.querySelector('.monogramming-extra-price')){
         //   document.querySelector('.monogramming-extra-price').innerText = `Monogram • ${priceMonogram}`;
         //   document.querySelector('.monogramming-extra-price').style.display = ``;
         // }
	}
    else if( typeof(data.eventTriggered) != "undefined" && data.eventTriggered == "motifProductAddToCart" ){
        // Adding monogram details to dom
        let personaliseBtn = document.querySelector(".customiser-label-top");
        personaliseBtn.classList.add('monogram-added');

        let motifRtnData = `Your Motif Option: 
                                  <span>
                                    ${data.motifImage} | 
                                    <img src="${derekRoseSSLPath + '/' + data.motifImagePath}" style="width: 15px;"/>
                                  </span>
                                  <span class="personalisation-details">_Motif Reference:${data.motifImage}</span>`;
      
        let motifDetailsDom = document.querySelector('.monogram-after.new-added');      
        let motifDetails  = `<span class="monogram-details">
                                <svg style="display:inline-block; vertical-align:middle" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M6 0C2.68548 0 0 2.70968 0 6C0 9.31452 2.68548 12 6 12C9.29032 12 12 9.31452 12 6C12 2.70968 9.29032 0 6 0ZM6 2.66129C6.55645 2.66129 7.01613 3.12097 7.01613 3.67742C7.01613 4.25806 6.55645 4.69355 6 4.69355C5.41935 4.69355 4.98387 4.25806 4.98387 3.67742C4.98387 3.12097 5.41935 2.66129 6 2.66129ZM7.35484 8.80645C7.35484 8.97581 7.20968 9.09677 7.06452 9.09677H4.93548C4.76613 9.09677 4.64516 8.97581 4.64516 8.80645V8.22581C4.64516 8.08064 4.76613 7.93548 4.93548 7.93548H5.22581V6.3871H4.93548C4.76613 6.3871 4.64516 6.26613 4.64516 6.09677V5.51613C4.64516 5.37097 4.76613 5.22581 4.93548 5.22581H6.48387C6.62903 5.22581 6.77419 5.37097 6.77419 5.51613V7.93548H7.06452C7.20968 7.93548 7.35484 8.08064 7.35484 8.22581V8.80645Z" fill="#000"></path>
                                </svg><span style="display:inline-block; vertical-align:middle">&nbsp; <span style="border-bottom: 1px solid black;"> <a href="${termConditionURL}" target="_blank">Terms &amp; Conditions</a></span> Accepted</span>
                              </span>`;
        motifDetails += `<span class="monogram-update">
                        <a href="javascript:;" onclick="openPopup('EditMotif')" class="monogram-edit">Edit</a> |
                        <a href="javascript:;" onclick="deleteMonogram()" class="monogram-delete">Remove</a>
                      </span>`;
      
        motifDetailsDom.innerHTML = motifDetails;
        motifDetailsDom.style.display = "";

        document.querySelector('.customiser-price-feld.new-added').innerHTML = motifRtnData;
        document.querySelector('.customiser-price-feld.new-added').style.display = "";
        personaliseBtn.style.display = "";

        //Hiding the Add monogram Button 
        document.querySelector('.monogram-before').style.display = 'none';
        document.querySelector('.customiser-price-feld.old-added').style.display = 'none';
        document.querySelector('.sew-text.old-added').style.display = 'none';

        //Remove Popup
        document.body.style.overflow = "unset";
        document.body.style.height = "unset";
        document.body.style.margin = "inherit";
        document.getElementById("popup-overlay").style.display = "none";

        var cartProperties = {};

        cartProperties['_is_motif'] = 'Yes';
        cartProperties['Motif'] = data.motifImage;
        cartProperties['_Related Product Id'] = data.parentProductId;
        cartProperties['_Related Product Name'] = "";
        cartProperties['_Reference Image'] = data.imageDataURI;
      
        let imageUrl = new URL(data.imageDataURI);

        if(motifEditUrl.searchParams.has('motifImage')){
           motifEditUrl.searchParams.set('motifImage', imageUrl.searchParams.get("motifImage"));
        }
        else{
           motifEditUrl.searchParams.append('motifImage', imageUrl.searchParams.get("motifImage"));
        }

        if(motifEditUrl.searchParams.has('editPrice')){
           motifEditUrl.searchParams.set('editPrice', motifPrice);
        }
        else{
           motifEditUrl.searchParams.append('editPrice', motifPrice);
        }

        let myPriceStringEdit = monogramVariantPrices.join("_");
        if(motifEditUrl.searchParams.has('editPrice')){
           motifEditUrl.searchParams.set('priceString', myPriceStringEdit);
        }
        else{
           motifEditUrl.searchParams.append('priceString', myPriceStringEdit);
        }

        if(motifEditUrl.searchParams.has('code')){
           motifEditUrl.searchParams.set('code', window.Shopify.currency.active);
        }
        else{
           motifEditUrl.searchParams.append('code', window.Shopify.currency.active);
        }
      
        if(motifEditUrl.searchParams.has('editMotif')){
           motifEditUrl.searchParams.set('editMotif', "true");
        }
        else{
           motifEditUrl.searchParams.append('editMotif', "true");
        }

        /* add product into the cart */
        let productId = 3;
        var strToChange = {
          id : monogramArray[productId],
          properties: cartProperties,
          quantity: data.quantity
        }
       
        var Cartitems = {};
        Cartitems['items'] = [];
        Cartitems.items.push(strToChange); 
      
        document.getElementById("monogramming-details").value = JSON.stringify(strToChange);
        const options = { style: 'currency', currency: window.Shopify.currency.active };
        const numberFormat = new Intl.NumberFormat( "en-US" , options);
        var prize = Shopify.formatMoney(motifPrice, shopMoneyFormat);
        const parts = numberFormat.formatToParts(parseInt(motifPrice)); 

        /*let priceMotif = `${parts[0].value}${parts[1].value}${parts[2].value}${parts[3].value}`;

        if(window.Shopify.currency.active  == 'EUR'){
          priceMotif = priceMotif.replace(".", ",");
        }
        */

        if(document.querySelector('.sew-text.new-added')){
          document.querySelector('.sew-text.new-added').innerHTML = `Personalisation: Motif <span class="monogramming-extra-price"> ${motifPrice}</span>`;
          document.querySelector('.sew-text.new-added').style.display = ``;
        }
      
        // if(document.querySelector('.monogramming-extra-price')){
        //  document.querySelector('.monogramming-extra-price').innerText = `Motif • ${priceMotif}`;
        //  document.querySelector('.monogramming-extra-price').style.display = ``;
        // }
    }
    else if( typeof(data.eventTriggered) != "undefined" && data.eventTriggered == "secretMsgProductAddToCart" ){
        
        var arrSecretMessages = (data.secretMsgs).split('##');
        var colourWay = data.colourWay;
        var colourWayCode = data.colourWayCode;
        var arrcolourWayData = colourWay;
      
        // Adding monogram details to dom
        let personaliseBtn = document.querySelector(".customiser-label-top");
        personaliseBtn.classList.add('monogram-added');

        var secretMessageDetail = arrSecretMessages[0] + " / " + colourWay
        if(arrSecretMessages[1] != ""){
          secretMessageDetail = arrSecretMessages[0] + " / " + arrSecretMessages[1] + " / " + colourWay
        }

        let secretMessageRtnData = `Your Secret Message: 
                                  <span>
                                    <p> ${arrSecretMessages[0]} <br/>
                                     ${arrSecretMessages[1]} </p>
                                  </span>
                                  Colourway (Fabric/Thread): ${colourWay} 
                                  <span class="personalisation-details">_SM Reference:${secretMessageDetail}</span>`;
        
        let secretMsgDetailsDom =  document.querySelector('.monogram-after.new-added');       
        let secretMsgDetails  = `<span class="monogram-details">
                                  <svg style="display:inline-block; vertical-align:middle" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 0C2.68548 0 0 2.70968 0 6C0 9.31452 2.68548 12 6 12C9.29032 12 12 9.31452 12 6C12 2.70968 9.29032 0 6 0ZM6 2.66129C6.55645 2.66129 7.01613 3.12097 7.01613 3.67742C7.01613 4.25806 6.55645 4.69355 6 4.69355C5.41935 4.69355 4.98387 4.25806 4.98387 3.67742C4.98387 3.12097 5.41935 2.66129 6 2.66129ZM7.35484 8.80645C7.35484 8.97581 7.20968 9.09677 7.06452 9.09677H4.93548C4.76613 9.09677 4.64516 8.97581 4.64516 8.80645V8.22581C4.64516 8.08064 4.76613 7.93548 4.93548 7.93548H5.22581V6.3871H4.93548C4.76613 6.3871 4.64516 6.26613 4.64516 6.09677V5.51613C4.64516 5.37097 4.76613 5.22581 4.93548 5.22581H6.48387C6.62903 5.22581 6.77419 5.37097 6.77419 5.51613V7.93548H7.06452C7.20968 7.93548 7.35484 8.08064 7.35484 8.22581V8.80645Z" fill="#000"></path>
                                  </svg><span style="display:inline-block; vertical-align:middle">&nbsp; <span style="border-bottom: 1px solid black;"> <a href="${termConditionURL}" target="_blank">Terms &amp; Conditions</a></span> Accepted</span>
                                </span>`;
        secretMsgDetails += `<span class="monogram-update">
                        <a href="javascript:;" onclick="openPopup('EditSecretMsg')" class="monogram-edit">Edit</a> |
                        <a href="javascript:;" onclick="deleteMonogram()" class="monogram-delete">Remove</a>
                      </span>`;
      
        secretMsgDetailsDom.innerHTML = secretMsgDetails;
        secretMsgDetailsDom.style.display = "";

        document.querySelector('.customiser-price-feld.new-added').innerHTML = secretMessageRtnData;
        document.querySelector('.customiser-price-feld.new-added').style.display = "";
        personaliseBtn.style.display = "";

        //Hiding the Add monogram Button 
        document.querySelector('.monogram-before').style.display = 'none';
        document.querySelector('.customiser-price-feld.old-added').style.display = 'none';
        document.querySelector('.sew-text.old-added').style.display = 'none';

        //Remove Popup
		document.body.style.overflow = "unset";
        document.body.style.height = "unset";
        document.body.style.margin = "inherit";
        document.getElementById("popup-overlay").style.display = "none";

        var cartProperties = {};

        cartProperties['_is_secret_message'] = 'Yes';
        cartProperties['SM_Line1'] = arrSecretMessages[0];
        cartProperties['SM_Line2'] = arrSecretMessages[1];
        cartProperties['Colourway'] = arrcolourWayData;
        cartProperties['_Related Product Id'] = data.parentProductId;
        cartProperties['_Related Product Name'] = "";
        cartProperties['_Reference Image'] = data.imageDataURI;
      
        let imageUrl = new URL(data.imageDataURI);
      

        if(secretMsgEditUrl.searchParams.has('secretMsgs')){
           secretMsgEditUrl.searchParams.set('secretMsgs', (arrSecretMessages[0] + "##" + arrSecretMessages[1]));
        }
        else{
           secretMsgEditUrl.searchParams.append('secretMsgs', (arrSecretMessages[0] + "##" + arrSecretMessages[1]));
        }

        if(secretMsgEditUrl.searchParams.has('Colourway')){
           secretMsgEditUrl.searchParams.set('Colourway', colourWayCode);
        }
        else{
           secretMsgEditUrl.searchParams.append('Colourway', colourWayCode);
        }

        if(secretMsgEditUrl.searchParams.has('editPrice')){
           secretMsgEditUrl.searchParams.set('editPrice', secretMsgPrice);
        }
        else{
           secretMsgEditUrl.searchParams.append('editPrice', secretMsgPrice);
        }

        let myPriceStringEdit = monogramVariantPrices.join("_");
        if(secretMsgEditUrl.searchParams.has('editPrice')){
           secretMsgEditUrl.searchParams.set('priceString', myPriceStringEdit);
        }
        else{
           secretMsgEditUrl.searchParams.append('priceString', myPriceStringEdit);
        }

        if(secretMsgEditUrl.searchParams.has('code')){
           secretMsgEditUrl.searchParams.set('code', window.Shopify.currency.active);
        }
        else{
           secretMsgEditUrl.searchParams.append('code', window.Shopify.currency.active);
        }
      
        if(secretMsgEditUrl.searchParams.has('editSecretMsg')){
           secretMsgEditUrl.searchParams.set('editSecretMsg', "true");
        }
        else{
           secretMsgEditUrl.searchParams.append('editSecretMsg', "true");
        }

        /* add product into the cart */
        let productId = 4;
        var strToChange = {
          id : monogramArray[productId],
          properties: cartProperties,
          quantity: data.quantity
        }
       
        var Cartitems = {};
        Cartitems['items'] = [];
        Cartitems.items.push(strToChange); 
      
        document.getElementById("monogramming-details").value = JSON.stringify(strToChange);
        const options = { style: 'currency', currency: window.Shopify.currency.active };
        const numberFormat = new Intl.NumberFormat( "en-US" , options);
        const parts = numberFormat.formatToParts(parseInt(secretMsgPrice)); 

        /*
        let priceSecretMesg = `${parts[0].value}${parts[1].value}${parts[2].value}${parts[3].value}`;

        if(window.Shopify.currency.active  == 'EUR'){
          priceSecretMesg = priceSecretMesg.replace(".", ",");
        }
        */

        if(document.querySelector('.sew-text.new-added')){
           document.querySelector('.sew-text.new-added').innerHTML = `Personalisation: Message <span class="monogramming-extra-price"> ${secretMsgPrice}</span>`;
           document.querySelector('.sew-text.new-added').style.display = ``;
         }
      
        // if(document.querySelector('.monogramming-extra-price')){
        //  document.querySelector('.monogramming-extra-price').innerText = `Secret Message • ${priceSecretMesg}`;
        //  document.querySelector('.monogramming-extra-price').style.display = ``;
        // }
    }
    else if( typeof(data.eventTriggered) != "undefined" && data.eventTriggered == "removePersonalisation" ){      
        deleteMonogram();
        closePopup();
	}
	else if( typeof(data.eventTriggered) != "undefined" && data.eventTriggered == "closePlugin" ){		
		if($('#personalizedPopUp').length > 0){			
			$('#personalizedPopUp').html('');
		}			
	}
	
	else if( typeof(data.eventTriggered) != "undefined" && data.eventTriggered == "updatePersonalizedProduct" ){
		
		if($('#personalizedPopUp').length > 0){
			
			//Call Ajax for add product details into custom db
			
			var url = CardGallerySSLPath + "ajax/getproductcofigdetails.php";
			
			/* Update Personalize Data */
			$.ajax({
				url: url,
				type: "POST",
				crossDomain: true,
				data : {
					"doAction"	: "updatePersonalizeProduct",
					"personalizeId" 	: data.personalizeId,
					"customizeDetails" 	: data.customizeDetails,
					"customImages" 	: data.customImages,
					"viewImages" 	: data.viewImages,
					"usedFonts" 	: data.usedFonts,
					"imageDataURI" 		: data.imageDataURI,
					"r" 		: Math.random()
				},
				async: false, 
				success:function(result) {
					if(result != "") {
						
						var rsltInfo = jQuery.parseJSON(result);
						
						if(rsltInfo.status){
							alert(rsltInfo.message);
						}
						else{
							alert(rsltInfo.message);
						}
						
					}
					else{
						alert("This Product is not Available for Customization. Please Try another Product");
					}
				}
				
			});
			
			//Remove Popup
			$('#personalizedPopUp').html('');
		}
			
	}
	
}

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};